import qsc from '../../scripts/util/dom/qsc';
import addClass from '../../scripts/util/dom/addClass';
import rmc from '../../scripts/util/dom/rmc';

const selectors = {
	body: '.js-body',
	wrapper: '.js-page-wrapper'
};

const classes = {
	bodyNoScroll: 'page_noscroll'
};

const body = qsc(selectors.body);
const wrapper = qsc(selectors.wrapper);

const disableScroll = () => {
	addClass(classes.bodyNoScroll, body());
	addClass(classes.bodyNoScroll, wrapper());
};

const enableScroll = () => {
	rmc(classes.bodyNoScroll, body());
	rmc(classes.bodyNoScroll, wrapper());
};

export {
	disableScroll,
	enableScroll
};





/** WEBPACK FOOTER **
 ** ./app/blocks/page/page.js
 **/